/* ============================================================
   TRADIE BITS — theme.js
   Mobile nav, qty steppers, gallery, AJAX add-to-cart, filters.
   ============================================================ */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* ---- Mobile nav drawer ---- */
    var burger = document.querySelector('[data-burger]');
    var drawer = document.querySelector('[data-drawer]');
    if (burger && drawer) {
      var open = function () { drawer.setAttribute('open', ''); document.body.style.overflow = 'hidden'; };
      var close = function () { drawer.removeAttribute('open'); document.body.style.overflow = ''; };
      burger.addEventListener('click', open);
      drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) {
        el.addEventListener('click', close);
      });
    }

    /* ---- Quantity steppers ---- */
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = btn.getAttribute('data-step') === 'down' ? -1 : 1;
          var val = parseInt(input.value, 10) || 1;
          val = Math.max(1, val + step);
          input.value = val;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    /* ---- /cart page qty: push changes to Shopify ----
       The steppers above only change the input's value; on the cart page
       that value has to be sent to /cart/change.js, then the page reloads
       so totals, discounts and the upsell card re-render server-side.
       Debounced so several quick taps send one request. */
    var cartQtyTimers = {};
    document.addEventListener('change', function (e) {
      var input = e.target.closest('.tb-cart-wrap input[name="updates[]"][data-line]');
      if (!input) return;
      var line = parseInt(input.getAttribute('data-line'), 10);
      var qty = Math.max(0, parseInt(input.value, 10) || 0);
      var itemEl = input.closest('.tb-cart-item');
      clearTimeout(cartQtyTimers[line]);
      cartQtyTimers[line] = setTimeout(function () {
        if (itemEl) itemEl.style.opacity = '0.5';
        fetch((window.tbRoutes && window.tbRoutes.cart_change) || '/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: line, quantity: qty })
        })
          .then(function () { window.location.reload(); })
          .catch(function () { window.location.reload(); });
      }, 400);
    });

    /* ---- Sticky mobile add-to-cart bar ---- */
    var stickyBar = document.querySelector('[data-sticky-atc]');
    var realAtcBtn = document.querySelector('form[data-product-form] .tb-atc');
    if (stickyBar && realAtcBtn && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { threshold: 0 });
      observer.observe(realAtcBtn);

      var stickyBtn = stickyBar.querySelector('[data-sticky-atc-button]');
      var realForm = document.querySelector('form[data-product-form]');
      if (stickyBtn && realForm) {
        stickyBtn.addEventListener('click', function () {
          realForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        });
      }
    }

    /* ---- Product gallery thumbnail switch ---- */
    var mainImg = document.querySelector('[data-gallery-main]');
    var thumbs = document.querySelectorAll('[data-gallery-thumb]');
    var galleryIndex = 0;
    function setGallerySlide(i) {
      if (!thumbs.length) return;
      galleryIndex = (i + thumbs.length) % thumbs.length;
      var thumb = thumbs[galleryIndex];
      var src = thumb.getAttribute('data-full');
      if (src && mainImg) mainImg.src = src;
      thumbs.forEach(function (t) { t.setAttribute('aria-current', 'false'); });
      thumb.setAttribute('aria-current', 'true');
    }
    if (mainImg) {
      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () { setGallerySlide(i); });
      });
      var prevBtn = document.querySelector('[data-gallery-prev]');
      var nextBtn = document.querySelector('[data-gallery-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { setGallerySlide(galleryIndex - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { setGallerySlide(galleryIndex + 1); });
    }

    /* ---- Product gallery: mobile swipe dots sync + prev/next buttons ---- */
    var swipe = document.querySelector('[data-swipe-gallery]');
    var dotsWrap = document.querySelector('[data-swipe-dots]');
    var slideCount = swipe ? swipe.querySelectorAll('.tb-gallery__swipe-slide').length : 0;
    function currentSwipeIndex() {
      var slideWidth = swipe.clientWidth || 1;
      return Math.round(swipe.scrollLeft / slideWidth);
    }
    function goToSwipeSlide(i) {
      if (!swipe || !slideCount) return;
      var idx = (i + slideCount) % slideCount;
      swipe.scrollTo({ left: idx * swipe.clientWidth, behavior: 'smooth' });
    }
    if (swipe && dotsWrap) {
      var dots = dotsWrap.querySelectorAll('.tb-gallery__dot');
      var setActive = function () {
        var idx = currentSwipeIndex();
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      };
      swipe.addEventListener('scroll', function () {
        window.requestAnimationFrame(setActive);
      }, { passive: true });
    }
    var swipePrev = document.querySelector('[data-swipe-prev]');
    var swipeNext = document.querySelector('[data-swipe-next]');
    if (swipePrev) swipePrev.addEventListener('click', function () { goToSwipeSlide(currentSwipeIndex() - 1); });
    if (swipeNext) swipeNext.addEventListener('click', function () { goToSwipeSlide(currentSwipeIndex() + 1); });

    /* ---- Collection: filter toggle (mobile) ---- */
    var fToggle = document.querySelector('[data-filters-toggle]');
    var fPanel = document.querySelector('[data-filters-panel]');
    if (fToggle && fPanel) {
      fToggle.addEventListener('click', function () { fPanel.classList.toggle('is-open'); });
    }

    /* ---- Collection: sort ---- */
    var sort = document.querySelector('[data-sort]');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        window.location.href = url.toString();
      });
    }

    /* ---- Locale / currency selector auto-submit ---- */
    document.querySelectorAll('[data-locale-select]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        if (sel.form) sel.form.submit();
      });
    });

    /* ---- Featured products swipe carousel ---- */
    document.querySelectorAll('[data-swipe-carousel]').forEach(function (carousel) {
      var row = carousel.querySelector('[data-swipe-row]');
      var prev = carousel.querySelector('[data-featured-swipe-prev]');
      var next = carousel.querySelector('[data-featured-swipe-next]');
      if (!row) return;
      function step() {
        var card = row.querySelector('.tb-card');
        return card ? card.getBoundingClientRect().width + 18 : row.clientWidth;
      }
      if (prev) prev.addEventListener('click', function () { row.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { row.scrollBy({ left: step(), behavior: 'smooth' }); });

      function toggleNav() {
        var scrollable = row.scrollWidth > row.clientWidth + 1;
        if (prev) prev.style.display = scrollable ? '' : 'none';
        if (next) next.style.display = scrollable ? '' : 'none';
      }
      toggleNav();
      window.addEventListener('resize', toggleNav);
    });

    /* ---- Volume discount tier selector ---- */
    document.querySelectorAll('[data-volume-widget]').forEach(function (widget) {
      var targetInput = document.getElementById(widget.getAttribute('data-qty-target'));
      if (!targetInput) return;
      widget.querySelectorAll('[data-volume-option]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          widget.querySelectorAll('.tb-volume__row').forEach(function (row) {
            row.classList.toggle('is-selected', row.contains(radio));
          });
          targetInput.value = radio.value;
          targetInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    /* ---- AJAX add to cart ---- */
    function updateCartCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
      });
    }

    // Cart line order isn't guaranteed to reflect add order, so the
    // upsell section can't infer "most recently added" from cart.items
    // alone. Stamp it explicitly as a cart attribute instead.
    function markLastAdded(handle) {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { last_added_handle: handle || '' } })
      }).then(function (r) { return r.json(); });
    }

    document.querySelectorAll('form[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (!window.tbRoutes) return; // fall back to native submit
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var original = btn ? btn.innerHTML : '';
        if (btn) { btn.innerHTML = 'ADDING…'; btn.disabled = true; }

        fetch(window.tbRoutes.cart_add + '.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        })
          .then(function (r) { return r.json(); })
          .then(function (item) { return markLastAdded(item.handle); })
          .then(function () {
            // No drawer popup on add — go straight to the cart page, where
            // the frequently-bought-with upsell renders under the item.
            window.location.href = window.tbRoutes.cart;
          })
          .catch(function () {
            // network error: hand off to the native cart page
            window.location.href = window.tbRoutes.cart;
          });
      });
    });

    /* ---- Cart drawer ---- */
    var cartDrawer = document.querySelector('[data-cart-drawer]');
    var cartBody = document.querySelector('[data-cart-drawer-body]');
    var cartFoot = document.querySelector('[data-cart-drawer-foot]');
    // Scoped to the drawer specifically — the full /cart page renders its
    // own upsell card server-side on load and doesn't need this AJAX refresh.
    var cartUpsellSlot = cartDrawer ? cartDrawer.querySelector('[data-cart-upsell]') : null;

    function fetchUpsell() {
      if (!cartUpsellSlot || !window.tbRoutes) return;
      fetch(window.tbRoutes.cart + '?section_id=cart-upsell')
        .then(function (r) { return r.text(); })
        .then(function (html) { cartUpsellSlot.innerHTML = html.trim(); })
        .catch(function () { cartUpsellSlot.innerHTML = ''; });
    }

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function openCartDrawer() {
      if (!cartDrawer) return;
      cartDrawer.setAttribute('open', '');
      document.body.style.overflow = 'hidden';
    }
    function closeCartDrawer() {
      if (!cartDrawer) return;
      cartDrawer.removeAttribute('open');
      document.body.style.overflow = '';
    }

    function renderCartDrawer(cart) {
      if (!cartBody || !cartFoot) return;
      if (!cart.items.length) {
        cartBody.innerHTML =
          '<div class="tb-cart-drawer__empty"><p>Your cart\u2019s empty \u2014 let\u2019s fix that.</p>' +
          '<a href="' + window.tbRoutes.all_products + '" class="tb-btn tb-btn--primary">SHOP THE TOOLS \u2192</a></div>';
        cartFoot.innerHTML = '';
        if (cartUpsellSlot) cartUpsellSlot.innerHTML = '';
        return;
      }
      var html = '';
      cart.items.forEach(function (item, i) {
        var img = item.image ? item.image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_200x200$1$2') : '';
        var variant = (item.variant_title && item.variant_title !== 'Default Title') ? '<div class="tb-cart-drawer__item-variant">' + item.variant_title + '</div>' : '';
        var discounted = item.original_line_price > item.final_line_price;
        var offLabel = item.quantity === 1
          ? Math.round((item.original_price - item.final_price) * 100 / item.original_price) + '% off'
          : 'Save ' + money(item.total_discount);
        var saleLine = discounted
          ? '<div class="tb-cart-drawer__item-variant"><s class="tb-cart-item__was">' + money(item.original_price) + '</s> ' + money(item.final_price) + ' each <span class="tb-cart-item__off">' + offLabel + '</span></div>'
          : '';
        html +=
          '<div class="tb-cart-drawer__item" data-line="' + (i + 1) + '">' +
            '<a href="' + item.url + '" class="tb-cart-drawer__item-img">' + (img ? '<img src="' + img + '" alt="' + item.product_title + '">' : '') + '</a>' +
            '<div>' +
              '<a href="' + item.url + '" class="tb-cart-drawer__item-title">' + item.product_title + '</a>' +
              variant +
              saleLine +
              '<div class="tb-cart-drawer__item-row">' +
                '<div class="tb-cart-drawer__qty">' +
                  '<button type="button" data-cart-qty-down aria-label="Decrease">\u2212</button>' +
                  '<span>' + item.quantity + '</span>' +
                  '<button type="button" data-cart-qty-up aria-label="Increase">+</button>' +
                '</div>' +
                '<button type="button" class="tb-cart-drawer__item-remove" data-cart-remove>Remove</button>' +
              '</div>' +
            '</div>' +
            '<div class="tb-cart-drawer__item-price">' + (discounted ? '<s class="tb-cart-item__was tb-cart-item__was--line">' + money(item.original_line_price) + '</s>' : '') + money(item.final_line_price) + '</div>' +
          '</div>';
      });
      var stickerImg = window.tbStickerImg || '';
      html += '<div class="tb-free-gift-note">' + (stickerImg ? '<img src="' + stickerImg + '" alt="Tradie Bits sticker" class="tb-free-gift-note__img" width="40" height="40">' : '') + '<span>FREE Tradie Bits Sticker comes with every order! No need to add it, it’s already sorted.</span></div>';
      cartBody.innerHTML = html;
      cartFoot.innerHTML =
        '<div class="tb-cart-drawer__subtotal"><span class="lbl">Subtotal</span><span class="amt">' + money(cart.total_price) + '</span></div>' +
        '<a href="' + window.tbRoutes.cart + '/checkout" class="tb-btn tb-btn--primary tb-btn--block">CHECKOUT</a>' +
        '<p class="tb-cart-drawer__note">Taxes & shipping calculated at checkout</p>';
      fetchUpsell();
    }

    function fetchCart() {
      if (!window.tbRoutes) return;
      fetch(window.tbRoutes.cart + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          renderCartDrawer(cart);
        });
    }

    function changeLine(line, quantity) {
      if (!window.tbRoutes) return;
      fetch(window.tbRoutes.cart_change, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          renderCartDrawer(cart);
        });
    }

    if (cartDrawer) {
      document.querySelectorAll('[data-cart-drawer-toggle]').forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.preventDefault();
          fetchCart();
          openCartDrawer();
        });
      });
      cartDrawer.querySelectorAll('[data-cart-drawer-close]').forEach(function (el) {
        el.addEventListener('click', closeCartDrawer);
      });
      cartBody.addEventListener('click', function (e) {
        var itemEl = e.target.closest('[data-line]');
        if (!itemEl) return;
        var line = parseInt(itemEl.getAttribute('data-line'), 10);
        if (e.target.closest('[data-cart-qty-up]')) {
          var span1 = itemEl.querySelector('.tb-cart-drawer__qty span');
          changeLine(line, parseInt(span1.textContent, 10) + 1);
        } else if (e.target.closest('[data-cart-qty-down]')) {
          var span2 = itemEl.querySelector('.tb-cart-drawer__qty span');
          var next = parseInt(span2.textContent, 10) - 1;
          changeLine(line, Math.max(0, next));
        } else if (e.target.closest('[data-cart-remove]')) {
          changeLine(line, 0);
        }
      });
    }

    // Delegated globally rather than scoped to the drawer, since the same
    // upsell card (and its Add button) also renders server-side on the
    // full /cart page (sections/main-cart.liquid via snippets/cart-upsell-card.liquid).
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cart-upsell-add]');
      if (!btn || !window.tbRoutes) return;
      var onCartPage = !btn.closest('[data-cart-drawer]');
      var variantId = btn.getAttribute('data-variant-id');
      var original = btn.textContent;
      btn.textContent = 'Adding…';
      btn.disabled = true;
      fetch(window.tbRoutes.cart_add + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function (item) { return markLastAdded(item.handle); })
        .then(function (cart) {
          if (onCartPage) {
            // Full page reload keeps the item list, subtotal and the next
            // upsell recommendation all correctly in sync in one step.
            window.location.reload();
            return;
          }
          updateCartCount(cart.item_count);
          renderCartDrawer(cart);
        })
        .catch(function () {
          btn.textContent = original;
          btn.disabled = false;
        });
    });
  });
})();
